import React from 'react';
import AgencyOrdersGraphQL from "./AgencyOrdersGraphQL";

function OrdersIndex(props) {
    return <AgencyOrdersGraphQL/>
}

export default OrdersIndex;
